<template>
  <div class="">
    <edit-agency-setups> </edit-agency-setups>
  </div>
</template>

<script>
import EditAgencySetups from "@/components/profile/agency-setups/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditAgencySetups,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Dati di Agenzia",
        path: "agency_setups.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Dati di Agenzia",
        path: "agency_setups.edit",
        level: 3,
      });
    }
  },
};
</script>
